module.exports = __webpack_public_path__ + "static/media/reference-slider-30.2c77694a.jpg";